import { createContentPropTypes } from '../../helpers/content';

const ratesErrorModalContent = {
	modalTitle: "Sorry, something's gone wrong",
	modalBody:
		"It looks like something's gone wrong in the background while obtaining an exchange rate and calculating this payment. Please go back and try submitting this payment again later.",
	modalOkButton: 'Ok',
};

export default ratesErrorModalContent;

export const contentPropTypes = createContentPropTypes(ratesErrorModalContent);
